import React from "react";
import PropTypes from "prop-types";
import {
  CvActionsFooterWrapper,
  DownloadCvButton,
} from "./styles/cv-actions-footer-styles";

const CvActionsFooter = (props) => {
  const { cvDownloadHandler } = props;

  return (
    <CvActionsFooterWrapper>
      <DownloadCvButton id="download-cv" onClick={cvDownloadHandler}>
        Download
      </DownloadCvButton>
    </CvActionsFooterWrapper>
  );
};

CvActionsFooter.propTypes = {
  cvDownloadHandler: PropTypes.func.isRequired,
};

export default CvActionsFooter;
